// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.profile-info-header[data-v-122fb8cd] {\n    font-weight: lighter !important;\n    color: #667d88 !important;\n}\n", ""]);
// Exports
module.exports = exports;
